import { ArrowDownOutlined } from '@ant-design/icons';
import { Divider, Empty, Select, Skeleton, Typography } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { DashboardContext } from '..';
import { logoBaseURL } from '../../../Utils/constants';
import {
  convertAmoutToINRWithNotation,
  groupByTransactions,
  groupByTransactionsCredit,
  groupByTransactionsDebit,
} from '../../../Utils/utils';
import styles from './index.module.css';

const AllTransactions: React.FC<{ selectedAccounts: string }> = ({
  selectedAccounts,
}) => {
  const [allTransactions, setAllTransactions] = useState<any>({});
  const [selectedMonth, setSelectedMonth] = useState();
  const [months, setMonths] = useState<any[]>([]);
  const [selectTxnType, setSelectedTxnType] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const txns = Object.keys(allTransactions);
    setLoading(false);
    if (txns.length > 0) {
      let monthDate: any = {};
      let array: any[] = [];
      txns.map((txn) => {
        var dateObject = new Date(txn);

        var month = dateObject
          .toLocaleString('en-US', { month: 'short' })
          .toLowerCase();

        var month1 = dateObject.toLocaleString('en-US', { month: 'long' });

        var year = dateObject.getFullYear().toString();

        var formattedDate = month + year.slice(-2);
        if (!monthDate[formattedDate]) {
          array.push({ value: formattedDate, label: month1 + ' ' + year });
          monthDate[formattedDate] = 1;
        }
      });
      setMonths(array);
    }
  }, [allTransactions]);

  useEffect(() => {
    setLoading(true);
    if (selectTxnType === 'credit') {
      setAllTransactions(groupByTransactionsCredit(selectedAccounts));
    } else if (selectTxnType === 'debit') {
      setAllTransactions(groupByTransactionsDebit(selectedAccounts));
    } else {
      setAllTransactions(groupByTransactions(selectedAccounts));
    }
  }, [selectTxnType, selectedAccounts]);

  const { setCurrentMetaData, setIsDetailedTransactionSheetOpen }: any =
    useContext(DashboardContext);

  const showItems = () => {
    return Object.keys(allTransactions).length > 0 ? (
      Object.keys(allTransactions)
        .filter((txn) => {
          if (selectedMonth) {
            var dateObject = new Date(txn);

            var month = dateObject
              .toLocaleString('en-US', { month: 'short' })
              .toLowerCase();
            var year = dateObject.getFullYear().toString().slice(-2);

            var formattedDate = month + year;
            return formattedDate === selectedMonth;
          } else return true;
        })
        .map((txn: any, i: number) => {
          const txnArray = allTransactions[txn];

          return (
            <>
              <Typography.Text
                style={{
                  color: 'rgba(117,119,121)',
                  fontSize: 12,
                }}
              >
                {txn}
              </Typography.Text>

              <div
                style={{
                  padding: 10,
                  background: 'white',
                  borderRadius: 10,
                  margin: '16px 0',
                }}
              >
                {txnArray.map((transaction: any, index: number) => {
                  const txn1 = transaction.displayName.split('-');
                  return (
                    <>
                      <div
                        onClick={() => {
                          setCurrentMetaData({
                            txn,
                            transaction,
                            index,
                            txnArray,
                            parentTransactions: allTransactions,
                            parentTransactionSetter: setAllTransactions,
                          });

                          setIsDetailedTransactionSheetOpen(true);
                        }}
                        className={styles.transactionCard}
                        id={i + transaction.dateOfTransaction}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                        >
                          <div className={styles.image_container}>
                            <img
                              src={
                                logoBaseURL +
                                transaction.merchantLogoCode +
                                '.jpg'
                              }
                              height={25}
                              style={{ objectFit: 'contain' }}
                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection: 'column',
                            }}
                          >
                            <div
                              style={{
                                marginTop: 10,
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                              }}
                            >
                              <Typography.Text
                                style={{
                                  color: 'rgb(40, 57, 100)',
                                  fontWeight: 500,
                                }}
                              >
                                {txn1 && txn1.length >= 2 ? txn1[1] : txn1[0]}
                              </Typography.Text>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                              }}
                            >
                              <Typography.Text
                                style={{
                                  color: 'rgba(117,119,121)',
                                  fontSize: '12px',
                                }}
                              >
                                {txn1 && txn1.length > 1 ? txn1[0] : 'Others'}
                                {/* {dayjs(transaction.dateOfTransaction).format('DD MMM YYYY')} */}
                              </Typography.Text>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            maxWidth: '30%',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Typography.Text
                            style={{ fontWeight: 500, wordBreak: 'keep-all' }}
                          >
                            ₹{convertAmoutToINRWithNotation(transaction.amount)}
                          </Typography.Text>
                          {transaction.type === 'CREDIT' ? (
                            <ArrowDownOutlined className={styles.creditArrow} />
                          ) : (
                            <ArrowDownOutlined className={styles.debitArrow} />
                          )}
                        </div>
                      </div>
                      {txnArray.length - 1 !== index ? (
                        <Divider style={{ margin: '6px 0px' }} />
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </div>
            </>
          );
        })
    ) : (
      <Empty description='No transactions found' />
    );
  };

  const handleChange = (e: any) => {
    setSelectedMonth(e);
  };

  const handleChangeTxnType = (e: any) => {
    setLoading(true);
    setSelectedTxnType(e);
  };

  return (
    <div className={`${styles.transactionContainer} transactionContainer`}>
      <div
        style={{
          padding: '10px',
          display: 'flex',
          gap: '15px',
        }}
      >
        <Select
          style={{
            height: 40,
            fontWeight: 600,
          }}
          allowClear
          rootClassName='transactionFilter'
          dropdownStyle={{ width: 150 }}
          onChange={handleChange}
          value={selectedMonth}
          title='Select Month'
          placeholder='Month'
          options={months}
        />
        <Select
          value={selectTxnType}
          rootClassName='transactionFilter'
          style={{
            height: 40,
            fontWeight: 600,
          }}
          allowClear
          onChange={handleChangeTxnType}
          placeholder='Transaction Type'
          options={[
            { value: 'credit', label: 'Credit' },
            { value: 'debit', label: 'Debit' },
          ]}
        />
      </div>
      <div>
        <Skeleton loading={loading} active>
          {showItems()}
        </Skeleton>
      </div>
    </div>
  );
};

export default AllTransactions;
